import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from '@chakra-ui/react';

const CUIContainer = args => {
  return /*#__PURE__*/_jsx(Container, Object.assign({}, args));
};

export default CUIContainer;